module.exports = __webpack_public_path__ + "img/logo-soma-square.6da5366d.svg";